module.exports = __webpack_public_path__ + "img/i5gam-no-img.137b376a.png";